var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    { attrs: { name: "modal-complaint-created", width: 600 } },
    [
      _c("div", [
        _c(
          "header",
          {
            staticClass:
              "modal-header py25 px65 h3 sans-serif weight-800 bg-cl-secondary"
          },
          [
            _vm._v("\n    " + _vm._s(_vm.$t("Complaint created")) + "\n    "),
            _c(
              "i",
              {
                staticClass: "modal-close material-icons cl-bg-tertiary",
                attrs: { slot: "close" },
                on: { click: _vm.close },
                slot: "close"
              },
              [_vm._v("\n      close\n    ")]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "modal-content bg-cl-primary pt20 pb30 px65 cl-dark" },
          [
            _c("div", { staticClass: "row mb15" }, [
              _c(
                "div",
                { staticClass: "col-xs-12" },
                [
                  _c("cms-block-chunk", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.getRmaType() === 1,
                        expression: "getRmaType() === 1"
                      }
                    ],
                    attrs: {
                      identifier: "c_COMPLAINT_DOOR_2_DOOR_SENT",
                      "default-value": "<p/>"
                    }
                  }),
                  _vm._v(" "),
                  _c("cms-block-chunk", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.getRmaType() === 2,
                        expression: "getRmaType() === 2"
                      }
                    ],
                    attrs: {
                      identifier: "c_COMPLAINT_SENT",
                      "default-value": "<p/>"
                    }
                  }),
                  _vm._v(" "),
                  _c("cms-block-chunk", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.getRmaType() === 3,
                        expression: "getRmaType() === 3"
                      }
                    ],
                    attrs: {
                      identifier: "c_COMPLAINT_PRINTE_SENT",
                      "default-value": "<p/>"
                    }
                  }),
                  _vm._v(" "),
                  _c("cms-block-chunk", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.getRmaType() === 4,
                        expression: "getRmaType() === 4"
                      }
                    ],
                    attrs: {
                      identifier: "c_COMPLAINT_DOM_i_BIURO_SENT",
                      "default-value": "<p/>"
                    }
                  })
                ],
                1
              )
            ])
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }